export const navbarIcons = {
  notifications: 'assets/icons/notifications.svg',
  notifications_badge: 'assets/icons/notifications_badge.svg',
} as const;

export type NavbarIconKey = keyof typeof navbarIcons;
export const navbar = Object.keys(navbarIcons) as NavbarIconKey[];

export const allIcons = {
  accessibility_circle: 'assets/icons/accessibility_circle.svg',
  'mm-worker': 'assets/icons/mm-worker.svg',
  'mm-employeur': 'assets/icons/mm-employeur.svg',
  ...navbarIcons,
} as const;
